import { avatarColors, avatarInitials } from '@/features/panel/lib/avatar';

export function MsgAvatar({ displayName, externalId }: { displayName: string; externalId: string }) {
  const { bg, fg } = avatarColors(externalId);
  const initials = avatarInitials(displayName);
  return (
    <div
      aria-hidden="true"
      className="inline-flex items-center justify-center rounded-full text-2xs font-semibold leading-none select-none"
      style={{ width: '26px', height: '26px', backgroundColor: bg, color: fg }}
    >
      {initials}
    </div>
  );
}
